import ReactDOM from 'react-dom/client'
import { Toaster } from 'react-hot-toast'
import App from './App'
import { AuthProvider } from './contexts/Auth'
import ConfirmDialog from './shared/components/ConfirmationDialog'
import { AppThemeProvider } from './contexts/ThemeContext'
import { TenantBusinessProvider } from './contexts/TenantBusinessContext'

const container = document.getElementById('root') as HTMLElement
const root = ReactDOM.createRoot(container)

root.render(
    <AppThemeProvider>
        <AuthProvider>
            <TenantBusinessProvider>
                <App />
            </TenantBusinessProvider>
        </AuthProvider>
        <Toaster position="top-right" containerStyle={{ top: 80 }} />
        <ConfirmDialog />
    </AppThemeProvider>
)
